import Center from "layouts/wrapper/Center";
import style from "./HorizontalCategories2.module.css";
import Dummy from "components/Dummy";
import P from "components/P";
import { CategoryProvider } from "../../process/category/CategoryContext";
import CategoryTab from "../../process/category/CategoryTab";
import mainIcon from 'resources/img/puffu/mainIcon.png';
import MainGreyIcon from "resources/img/icons/MainGreyIcon";
import Inline from "layouts/container/Inline";
import CategoryTab2 from "../../process/category/CategoryTab2";


function HorizontalCategories2(props) {
    const {
        selectedCategory,
        mainCategoryTouchStart,
        mainCategoryTouchEnd,
        allCategoryTouchStart,
        allCategoryTouchEnd,
        categories,
        handleCategoryClick
    } = props;
    return (
        <div className={style.categoryArea}>
            <div
                style={{
                    width: "25%",
                    maxWidth: "25%",
                    // border: "1px solid var(--main-color)",
                    // borderRadius: "0",
                    backgroundColor: selectedCategory === 'main' ? "var(--point-color)" : "white",
                }}
                className={style.filterCategoryBtn}
                onPointerDown={mainCategoryTouchStart}
                onPointerUp={mainCategoryTouchEnd}
            >
                <div className={style.allBtn}>
                    <Center>
                        <Inline>
                            <MainGreyIcon width={"45px"} height={"45px"} color={selectedCategory === 'main' ? "white" : "#7B7B7B"} />
                            <Dummy width={"15px"} />
                            <P color={selectedCategory === 'main' ? "white" : "#7B7B7B"} weight={700} font={"Pretendard"} size={"1.8vw"}>메인</P>
                        </Inline>
                    </Center>
                </div>
            </div>
            {categories && categories.map((data, index) => (
                <div
                    key={data.id}
                    className={`${style.filterCategoryBtn} ${selectedCategory === data.id ? style.selectedCategory : ''}`}
                    // onPointerDown={() => handleCategoryClick(data.id)}
                    style={{ width: "25%", maxWidth: "25%", display: "flex", flexDirection: "column", justifyContent: categories.length > 3 ?  "center" : "flex-start" }}
                >
                    <CategoryTab2
                        key={data.id}
                        data={data}
                        onCategoryClick={handleCategoryClick}
                        selectedCategory={selectedCategory}
                    />

                </div>

            ))}
        </div>
    );
}

export default HorizontalCategories2;